/*
 * Copyright (c) 2020.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Nikita Tropin <ntropin@yandex.ru>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {Component, inject} from '@angular/core';
import {BaseFieldType, YoutubeVideoService} from 'compob2b-libs';

@Component({
    selector: 'app-youtube-preview',
    templateUrl: './youtube-preview.component.html',
    standalone: false
})
export class YoutubePreviewComponent extends BaseFieldType {

  youtubeVideoService = inject(YoutubeVideoService);
}
